import {typography} from 'material-ui/styles';

const styles = {
    content: {
        textAlign: 'center',
        padding: 30
    },
    title: {
        fontSize: 18,
        fontWeight: typography.fontWeightNormal,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: typography.fontWeightLight,
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/Error/Error.css.js